import actions from './live-stats.actions'
import getters from './live-stats.getters'

export default {
  namespaced: true,
  actions,
  getters,
}
